
package com.cybersoftsolution.cybersoftsolutionweb.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
actual data class RestorePasswordParams(
    actual var email: String  = "",
    actual var otp: Int?  = null,
    actual var password: String?  = null,
)
